import { useBreakpoint } from "@reactive-resume/hooks";
import { Panel, PanelGroup, PanelResizeHandle, ScrollArea } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";
import { Outlet } from "react-router";
import { useBuilderStore } from "@/client/stores/builder";

import { BuilderHeader } from "./_components/header";
import { LeftSidebar } from "./sidebar";
import { useViewStore } from "@/client/stores/view";
import { AnalysisSection } from "./sidebar/sections/analysis";
import { AnalysisProvider } from "@/client/contexts/analysis-context";
import { JobDescription } from "@/client/pages/builder/views/JobDescription";

const OutletSlot = () => {
  const activeView = useViewStore((state) => state.activeView);
  return (
    <>
      <BuilderHeader />

      {activeView === "builder" ? (
        <div className="absolute inset-0">
          <Outlet />
        </div>
      ) : activeView === "job-description" ? (
        <JobDescription />
      ) : (
        <ScrollArea orientation="vertical" className="h-screen flex-1 px-5 lg:pb-0 [&>div]:py-20">
          <AnalysisSection />
        </ScrollArea>
      )}
    </>
  );
};

export const BuilderLayout = () => {
  const { isDesktop } = useBreakpoint();

  const leftSetSize = useBuilderStore((state) => state.panel.left.setSize);
  const leftHandle = useBuilderStore((state) => state.panel.left.handle);

  return (
    <AnalysisProvider>
      <div className="relative size-full overflow-hidden">
        <PanelGroup direction="horizontal">
          <Panel
            minSize={isDesktop ? 35 : 40}
            maxSize={isDesktop ? 45 : 90}
            defaultSize={isDesktop ? 38 : 45}
            className={cn("bg-background z-10", !leftHandle.isDragging && "transition-[flex]")}
            onResize={leftSetSize}
          >
            <LeftSidebar />
          </Panel>
          <PanelResizeHandle
            isDragging={leftHandle.isDragging}
            onDragging={leftHandle.setDragging}
          />
          <Panel>
            <OutletSlot />
          </Panel>
        </PanelGroup>
      </div>
    </AnalysisProvider>
  );
};
